export const environment = {
  production: true,
  buildId: '3980437324824121',
  configFile: 'config.json',
};
